module.exports = __webpack_public_path__ + "img/bz.e8466061.jpg";